import axios from 'axios';
import PricingApi from './pricing/pricing.client';
import CoreApi from './core/core.client';
import AuthenticationApi from './authentication/authentication.client';
import AdminApi from './admin/admin.client';
import { LOCALSTORAGE_ACTIVE_SUPPLIER, LOCALSTORAGE_TOKEN_FIELD } from '../types/app.index';
import errorResponseHandler from './api.errorHandler';
import apiResponseHandler from './api.responseHandler';
import { SupplierModel } from './admin/admin.types';

axios.interceptors.request.use((config) => {
  const token = localStorage.getItem(LOCALSTORAGE_TOKEN_FIELD);
  const storedActiveSupplier = localStorage.getItem(LOCALSTORAGE_ACTIVE_SUPPLIER);
  let supplierCode;
  if (storedActiveSupplier) {
    const activeSupplier = JSON.parse(storedActiveSupplier) as SupplierModel;
    supplierCode = activeSupplier.code;
  }

  if (token) {
    if (config.url && supplierCode) {
      config.url = config.url.replace(':supplier', supplierCode);
    }

    if (config.url && (config.url.includes('rate-chain') || config.url.includes('localhost'))) {
      config.headers.Authorization = `Bearer ${token}`;
    }
  }
  return config;
});

axios.interceptors.response.use(
  (response) => apiResponseHandler(response),
  (error) => errorResponseHandler(error, AuthenticationApi.authentication.renewToken)
);

export {
  PricingApi,
  CoreApi,
  AuthenticationApi,
  AdminApi
};
